import React from "react";
import Callout from "components/Callout";

const CreatePriceCallout = ({ priceLabel }) => {
  return (
    <Callout
      copy={`No ${priceLabel} prices yet.`}
      customClasses={{
        container:
          "flex pa1 ba br2 items-center b--black-10 w-100 justify-between bg-content--secondary"
      }}
    />
  );
};
export default CreatePriceCallout;
